import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "w-full flex flex-wrap" }
const _hoisted_3 = { class: "w-10/12 pr-2" }
const _hoisted_4 = { class: "w-1/12" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Pesquisar ")
const _hoisted_6 = { class: "w-1/12 pl-2" }
const _hoisted_7 = { class: "mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_input = _resolveComponent("n-input")!
  const _component_SearchOutline = _resolveComponent("SearchOutline")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_ModalAdicionarSite = _resolveComponent("ModalAdicionarSite")!
  const _component_n_data_table = _resolveComponent("n-data-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_n_input, {
          class: "w-full",
          value: _ctx.formRef.search,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formRef.search) = $event)),
          type: "text",
          placeholder: "Titulo"
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_n_button, {
          type: "info",
          class: "w-full",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.search()))
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_SearchOutline)
          ]),
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_ModalAdicionarSite, {
          emitUpdate: () => _ctx.sites.fetch()
        }, null, 8, ["emitUpdate"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_n_data_table, {
        remote: "",
        ref: "table",
        columns: _ctx.columns,
        data: (_ctx.sites.data as any),
        loading: _ctx.sites.isLoading,
        pagination: _ctx.sites.pagination,
        "onUpdate:page": _ctx.sites.handlePageChange,
        "onUpdate:pageSize": _ctx.sites.handlePageSizeChange
      }, null, 8, ["columns", "data", "loading", "pagination", "onUpdate:page", "onUpdate:pageSize"])
    ])
  ]))
}